import { useContext } from 'react';
import Flex from '../../components/base/Flex';
import { useScandiumQuery } from '../../data-layer/utils';
import { AccountDetails } from './components/accountDetails';
import UsageStatistics from './components/usageStatistics';
import UserContext from '../../store/userState';
import PageLoader from '../../components/PageLoader';
import ErrorState from '../../components/base/ErrorState';
import OutlinedButton from '../../components/base/OutlinedButton';
import { Box } from '@mui/material/node';

const AccountUsage = () => {
  const { userData } = useContext(UserContext);
  const {
    data,
    isLoading: isFetchingCompanyDetails,
    isSuccess: fetchedCompanyDetails,
    refetch
  } = useScandiumQuery(`company/${userData?.user?.active_company?.id}`, {
    enabled: userData?.user?.active_company?.id
  });

  return (
    <Flex
      sx={{
        // px: '6rem',
        pt: '1rem',
        gap: '5rem',
        justifyContent: !isFetchingCompanyDetails ? 'flex-start' : 'center',
        alignItems: !isFetchingCompanyDetails ? 'flex-start' : 'center',
        height: 'fit-content',
        minHeight: '70vh',
        overflowY: 'hidden',
        pb: 0,
        boxSizing: 'border-box',
        width: '100%'
      }}>
      {isFetchingCompanyDetails ? (
        <Box>
          <PageLoader height={'100px'} />{' '}
        </Box>
      ) : fetchedCompanyDetails ? (
        <Box
          sx={{
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: '2rem', md: '5rem' },
            width: '100%'
          }}>
          <AccountDetails companyData={data?.data} />
          <UsageStatistics companyData={data?.data} />
        </Box>
      ) : (
        <ErrorState
          cta={
            <OutlinedButton
              onClick={() => {
                refetch();
              }}>
              Retry
            </OutlinedButton>
          }
        />
      )}
    </Flex>
  );
};

export default AccountUsage;
